import { IGNORED_ROUTES, QueryKeys } from "@/constants";
import FeatureListItemLin from "../components/home/feature-list-item-lin";
import FeatureListItem from "../components/home/feature-list-item";
import FeaturesSkeleton from "./features-skeleton";
import type Feature from "@/model/features";
import HccbWrapper from "../components/home/feature-list-item-hcbb";
import { Loader2 } from "lucide-react";
import { useFeatures } from "@/hooks/use-features";

function Features() {
  const featuresQuery = useFeatures();

  if (featuresQuery.isLoading) return <FeaturesSkeleton />;

  return (
    <div className="mb-8">
      <div className="flex flex-wrap gap-6">
        {featuresQuery.data?.map((feature: Feature, index: number) => {
          const ignoredFeature = IGNORED_ROUTES.find(
            (route) => route.path === feature.action?.web_route,
          );
          if (ignoredFeature) return null;

          if (feature.action?.web_route === QueryKeys.EBIX) {
            return (
              <FeatureListItemLin
                key={index}
                keyValue={index}
                feature={feature}
              />
            );
          } else if (feature.action?.web_route === QueryKeys.HCCB) {
            return (
              <HccbWrapper key={index} feature={feature}>
                {({ onClick, isPending }) => (
                  // 2.1.1 Keyboard — A / 4.1.2 — A: was a <Card onClick>, i.e. a
                  // non-focusable <div>. See feature-list-item.tsx for the full note.
                  <button
                    type="button"
                    onClick={onClick}
                    className={`add-class order-[${feature.order}] flex h-[110px] w-[110px] cursor-pointer flex-col items-center justify-start gap-4 rounded-xl border-0 bg-card p-2 pt-5 text-card-foreground shadow-md hover:bg-primary-extraLight focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2`}
                  >
                    {isPending ? (
                      <Loader2
                        aria-hidden="true"
                        className="size-10 animate-spin text-blue-500 motion-reduce:animate-none"
                      />
                    ) : (
                      <div className="aspect-square h-8">
                        <img
                          src={`data:image/svg+xml;base64,${feature.icon}`}
                          alt=""
                          className="h-full object-contain"
                        />
                      </div>
                    )}
                    <span className="overflow-hidden text-ellipsis text-center text-sm font-medium leading-none">
                      {feature.name}
                    </span>
                  </button>
                )}
              </HccbWrapper>
            );
          } else {
            return (
              <FeatureListItem key={index} keyValue={index} feature={feature} />
            );
          }
        })}
      </div>
    </div>
  );
}

export default Features;
